const forgottenPassword = ({ email }) => ({
  endpoint: '/api/request-password-reset',
  type: 'FORGOTTEN_PASSWORD',
  options: {
    method: 'POST',
    body: {
      email,
    },
  },
});

const resetPassword = ({ password1, password2, token }) => ({
  endpoint: '/api/reset-password',
  type: 'RESET_PASSWORD',
  options: {
    method: 'POST',
    body: {
      password: password1,
      password_confirmation: password2,
      reset_token: token,
    },
  },
});

export { forgottenPassword, resetPassword };
